module.exports = __webpack_public_path__ + "static/media/email.921ef843.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/email.svg
// module id = 247
// module chunks = 1